/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {AfterContentChecked, Component, HostListener, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {XrefBulkUploadModalComponent} from "./components/xref-bulk-upload-modal/xref-bulk-upload-modal.component";
import {XrefAddRecipientModalComponent} from "./components/xref-add-recipient-modal/xref-add-recipient-modal.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {
  SelectQuestionnaireModalComponent
} from "./components/select-questionnaire-modal/select-questionnaire-modal.component";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {RequestService} from "../../services/request/request.service";
import {PeopleService} from '../../services/people/people.service';
import {EmailSmsPlaceholderModalComponent} from "../email-sms-placeholder-modal/email-sms-placeholder-modal.component";
import * as Cookies from "js-cookie";
import {OrganisationService} from "../../services/organisation/organisation.service";
import {Router} from "@angular/router";
import {IsDirty} from "../../services/can-deactivate-guard/is-dirty.interface";
import {WarningModalContentComponent} from "../../lib/warning-modal/warning-modal.component";
import {setPageDirtyFlag} from '../../../app/shared/page-dirty-flag'; //'src/app/shared/page-dirty-flag'
import {ConstantsService} from '../../../app/services/constants/constants.service';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {
  XrefAddReferenceRecipientModalComponent
} from "./components/xref-add-reference-recipient-modal/xref-add-reference-recipient-modal.component";
import {ListRecipientsModalComponent} from "./components/list-recipients-modal/list-recipients-modal.component";
import { PlanService } from '../../../app/services/plan-status/plan-status.service';
import {XrefAddPulseRecipientModalComponent} from './components/xref-add-pulse-recipient-modal/xref-add-pulse-recipient-modal.component';
import {ChangeDetectorRef} from '@angular/core';
import moment from 'moment';
import { XrefCutOffScheduleDatePickerModalComponent } from './components/xref-cut-off-schedule-date-picker-modal/xref-cut-off-schedule-date-picker-modal.component';
import { getParam } from 'src/app/shared/utils';
import {filter, first, forkJoin, Observable, Subject, take, throwError} from 'rxjs';
import {
  AddRecipientBackgroundCheckModalComponent
} from "./components/add-recipient-background-check-modal/add-recipient-background-check-modal.component";
import { SelectBackgroundCheckModalComponent } from './components/select-background-check-modal/select-background-check-modal.component';
import { SelectTemplateModalComponent } from './components/select-template-modal/select-template-modal.component';
import {TrustMarketplaceStatusService} from "../../services/trust-marketplace-status/trust-marketplace-status.service";
import { ClearDraftService } from "../../shared/clear-draft.service";
import {BackgroundChecksService} from "../../services/background-checks/background-checks.service";
import { cloneDeep } from 'lodash';
import {catchError, finalize, takeUntil, tap} from "rxjs/operators";
import {QuestionnaireService} from "../../services/questionnaire/questionnaire.service";
import {LockedFeatureModalComponent} from "../locked-feature-modal/locked-feature-modal.component";
import {environment} from "../../../environments/environment";
import {XmeService} from "../../services/xme/xme.service";
import {
  XmeMatchCase,
  XmeSearchResponse,
  XmeSearchResultTeaser,
  isXmeRequestedUnlockStatus,
  toSearchResultTeaser
} from "../../services/xme/xme.model";
import { appendXmeOrigin, XmeOriginState } from "../../services/xme/xme-origin";

export type XmeSearchState = 'idle' | 'searching' | 'no-match' | 'matched' | 'requested';

@Component({
  selector: 'app-send-xref',
  templateUrl: './send-xref.component.pug',
  styleUrls: ['./send-xref.component.scss'],
  standalone: false
})
export class SendXrefComponent implements OnInit, OnChanges, OnDestroy, IsDirty, AfterContentChecked {

  questionnaireSelected!: any;
  shouldOpenSelectCheckModal = false;
  questionnaireList!: any;
  recipients = {};
  updatedTemplates: {}[] = [];
  templates: {}[] = [];
  filterRecipients = '';
  total = 0;
  totalCheck = 0;
  recipientLoader = false;
  checkType = ConstantsService.REFERENCE_CHECK;
  countOfRecipientsWithoutMobile = 0;
  templateVariables: any[] = [];
  questionnaireIdSelected = 0;
  criteriaID = 0;
  backgroundCheckButtonText = $localize`Add checks`;
  questionnaireButtonText = $localize`Select survey`;
  sendRequestButton = $localize`Send request`
  neverUsedLabel = $localize`Never used`
  defaultLogo = ConstantsService.DEFAULT_LOGO;
  draftUid: string | null = '';
  draftReferenceUid: string | null = '';
  draftBackgroundCheckUid: string | null = '';
  draftPulseUid: string | null = '';
  private bsModalRef: any;
  private bsModalRefShowAll: any;
  disableSend = true;
  loading = false;
  inValidRecipients = false;
  draftResponse = {};
  errorCount = 0;
  warningCount = 0;
  filterCount = 0;
  editPulse = ''
  criteria = false;
  bulkSendAvailable = true;
  org = {};
  orgUid = Cookies.get('xreforgid');
  preFill = false;
  isCutoffCustomised = false;
  renderComp: any
  cutOffExpiry={
    date:'',
    time:'',
    timeZone:''
  }
  scheduleExpiry={
    date:'',
    time:'',
    timeZone:''
  }
  defaultTimeZone!: string;

  isFirstOpen = false;
  isScheduleDateTimeSet = false
  isScheduleDateTimeInPast = false
  isReceipentUptoLimit = false
  editPulseCustomised = false;
  editingRequest = false
  disableSection = false
  tmpAdminStatus: number | undefined = 1;
  creditsAllocated;
  creditsRemaining;
  creditsUsed;
  clearDraftServiceSubscription;
  requestSettingsWarning = false
  bgCheckShortNames: any = [];
  isTrialUser = false;
  ent_10781_signup_improvements = false;

  errorMap = new Map([
    ["package", new Map<any, any>([["invalid", {
      'message': $localize`The survey selected no longer exists. Please choose another survey to continue.`,
      'type': 'danger'
    }
    ]])],
    ["placeholders", new Map<any, any>([["invalid", {
      'message': $localize`Ensure all required placeholders are included in your email & SMS to send your request. `,
      'type': 'danger'
    }
    ]])],
  ]);
  messages: Array<any> = [];
  attachToFooter = false;
  pulseActivated = false;
  defaultPayload = {
    "referenceCount": 2,
    "coverageCount": 2,
    "timeGap": 4,
    "selectedTimeGapPeriod": 'Weeks',
    "allowTimeGaps": false,
    "noteToCandidate": '',
    "noteToReferee": '',
    "hiringAccount": 0,
    "coverageCountAdded": false
  }
  defaultNotes = {
    "noteToCandidate": '',
    "noteToReferee": ''
  }
  sfcdId='';
  updatedRequestSettings = {};
  exitCheck = ConstantsService.EXIT_CHECK;
  referenceCheck = ConstantsService.REFERENCE_CHECK;
  pulseCheck = ConstantsService.PULSE_CHECK;
  backgroundCheck = ConstantsService.BACKGROUND_CHECK;

  ent_11525_unlock_xref_me = false;
  xmeState: XmeSearchState = 'idle';
  xmeQuery = '';
  xmeResult: XmeSearchResponse | null = null;
  xmeTeaser: XmeSearchResultTeaser | null = null;
  /** Bumped on each search/reset so stale responses cannot overwrite newer UI state. */
  private xmeSearchGeneration = 0;
  xmeRequesting = false;
  xmeViewing = false;
  xmeInfoUrl = environment.XREF_ME_INFO_URL;
  xmeBadgeIconSrc = 'https://assets.xref.com/omni/shared/xref_me_badge_28.svg';
  xmeNoMatchIconSrc = 'https://assets.xref.com/omni/shared/error_amber.svg';
  xmeErrorIconSrc = 'https://assets.xref.com/omni/shared/red_alert_icon.svg';
  xmeSuccessIconSrc = 'https://assets.xref.com/omni/shared/check_badge_forest_12.svg';
  xmeHintArrowIconSrc = 'https://assets.xref.com/omni/shared/arrow_down_stone_16.svg';
  xmeSearchAnotherChevronSrc = 'https://assets.xref.com/omni/shared/chevron_right_forest_16.svg';
  xmeSearchPlaceholder = $localize`Enter email or Xref.me profile URL`;
  xmeSearchLabel = $localize`Search`;
  xmeSearchingLabel = $localize`Searching`;
  xmeIdVerifiedLabel = $localize`ID Verified`;
  xmeWorkEntitlementLabel = $localize`Work Entitlement`;
  xmeViewLabel = $localize`View`;
  xmeRequestLabel = $localize`Request access to verifications`;
  xmeVerifiedOnLabel = $localize`Verified on Xref.me`;
  xmeCareerCoverageCaption = $localize`Career coverage`;
  xmeEmploymentVerificationsCaption = $localize`Employment verifications`;
  xmeSupportingDocumentsCaption = $localize`Supporting documents`;
  xmeTimelineCaption = $localize`Timeline`;
  xmeReferencesLegendLabel = $localize`Role verifications`;
  xmeWorkHistoryLegendLabel = $localize`Work history`;
  xmeExplainedGapsLegendLabel = $localize`Explained gaps`;
  xmeSkipHint = $localize`Or skip and add a recipient manually below`;
  xmeSearchAnotherLabel = $localize`Search for another candidate`;
  xmeCreditFooter = '';
  xmeCreditHighlight: string | null = null;
  xmeNoMatchMessage = '';
  xmeRequestedMessage = '';
  xmePlatformErrorMessage = $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`;
  xmeInsufficientCreditMessage = $localize`Your subscription turnover cap has been reached. Contact your Account Owner to purchase an extension.`;
  filterBy = {
    'error': false,
    'warning': false
  };
  backgroundCheckTooltip = $localize`To enable background checks, you must connect to Trust Marketplace via account management.`
  hasBackgroundCheckPermissions = false;
  hasBulkUploadPermissions = false;
  bulkUploadTooltipText = ``;
  backgroundCheckBulkUploadTooltipText = `Bulk request is not available when multiple background checks are selected.`;
  backgroundCheckSelected!: any;
  flowSelected!: any;
  flowsSelected:any = [];
  backgroundCheckIdSelected = 0;
  selectedBackgroundChecks: any = [];
  backgroundChecksList:any = [];
  packageApiSettings: any = {};
  backgroundChecksData: any = {};
  selectedBackgroundChecksIds:any = [];
  checksLoading=true;
  disableRecipientListButtons = false;
  disable_replace = false

  canSendReferenceRequest = false;
  canSendPulseRequest = false;
  canSendExitRequest = false;
  canSendBackgroundRequest = false;
  canManageTemplate = false;
  backgroundMember = false;
  referenceMember = false;
  backgroundAdmin = false;
  referenceAdmin = false;
  TEMPLATE_REFERENCE_PERMISSION = $localize`Reference administrator permission is required to add a survey to a request template.`

  referenceRequestTooltip = '';
  pulseRequestTooltip = '';
  exitRequestTooltip = '';
  backgroundRequestTooltip = '';
  contactOwnerText = $localize`To top up your subscription,contact your Xref Account Manager`;
  cvsqBackgroundCheck = ConstantsService.CV_SQ_SHORT_NAME;
  cvhlBackgroundCheck = ConstantsService.CV_HL_SHORT_NAME;
  edusqBackgroundCheck = ConstantsService.EDUV_SQ_SHORT_NAME;
  eduhlBackgroundCheck = ConstantsService.EDUV_HL_SHORT_NAME;
  empsqBackgroundCheck = ConstantsService.EMPV_SQ_SHORT_NAME;
  empcpBackgroundCheck = ConstantsService.EMPV_CP_SHORT_NAME;
  flowAddtionalFieldsMapping = {
    [this.cvsqBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'],
    [this.edusqBackgroundCheck]: ['verification_qual_min', 'verification_qual_max'],
    [this.empsqBackgroundCheck]: ['verification_emp_min', 'verification_emp_max'],
    [this.empcpBackgroundCheck]: ['verification_years'],
  };
  flowNoAddtionalFieldsMapping = {
    [this.cvhlBackgroundCheck]: ConstantsService.CV_SHORT_NAME,
    [this.eduhlBackgroundCheck]: ConstantsService.EDUV_SHORT_NAME,
  };
  selectedTemplate :any;
  private destroy$ = new Subject<void>()

  get templateHasReference(): boolean {
    return !!this.selectedTemplate?.config?.find((c: any) => c.type === 'reference');
  }

  constructor(private modalService: BsModalService,
    public requestService: RequestService,
    private alertList: AlertBannerService,
    private organisationService: OrganisationService,
    private router: Router,
    private permissions: PermissionsService,
    private peopleService: PeopleService,
    public ngZone: NgZone,
    private planService: PlanService,
    private bgCheckService: BackgroundChecksService,
    private cdr: ChangeDetectorRef,
    private trustMarketplaceStatusService: TrustMarketplaceStatusService,
    private clearDraftService: ClearDraftService,
    private questionnaireService: QuestionnaireService,
    private xmeService: XmeService
  ) {
    this.checkType = this.router?.getCurrentNavigation()?.extras?.state?.checkType;
    this.preFill = this.router.getCurrentNavigation()?.extras?.state?.preFill;
    this.selectedTemplate = this.router?.getCurrentNavigation()?.extras?.state?.template;
  }

  loadTemplateData(): void {

    const referenceConfig = this.selectedTemplate.config?.find((c: any) => c.type === 'reference');
    if (referenceConfig && referenceConfig.package_id) {
      // Call getQuestionnaire to get the full questionnaire object
      this.questionnaireService.getQuestionnairePackage(referenceConfig.package_id.toString()).pipe(takeUntil(this.destroy$)).subscribe(
        (res) => {
          if (res && res.data) {
            this.questionnaireSelected = res.data;
            const config = this.questionnaireSelected?.config;
            const default_questionnaire = this.questionnaireSelected?.questionnaire?.is_default;

            if(referenceConfig.additional_details){
                const details = referenceConfig.additional_details;

                // Create new object to trigger change detection
                this.defaultPayload = {
                  ...this.defaultPayload,
                  referenceCount: details.min_referee || this.defaultPayload.referenceCount,
                  noteToCandidate: details.note_to_candidate || this.defaultPayload.noteToCandidate || '',
                  noteToReferee: details.note_to_referee || this.defaultPayload.noteToReferee || '',
                  coverageCount: details.coverage_count || this.defaultPayload.coverageCount || 2,
                  timeGap: details.gap_count || this.defaultPayload.timeGap,
                  allowTimeGaps: details.gap_count != null,
                  selectedTimeGapPeriod: details.gap_period || this.defaultPayload.selectedTimeGapPeriod,
                  coverageCountAdded: !!details.coverage_count
                };
                this.defaultNotes = {
                  noteToCandidate: details.note_to_candidate || '',
                  noteToReferee: details.note_to_referee || ''
                };
            }
            else{
                // Create new object to trigger change detection
                this.defaultPayload = {
                  ...this.defaultPayload,
                  referenceCount: config?.min_referee || 2
                };

                if(default_questionnaire){
                  this.defaultPayload.noteToCandidate = this.org['notes']?.note_to_candidate || '';
                  this.defaultPayload.noteToReferee = this.org['notes']?.note_to_referee || '';
                  this.defaultNotes = {
                    noteToCandidate: this.org['notes']?.note_to_candidate || '',
                    noteToReferee: this.org['notes']?.note_to_referee || ''
                  };
                }
                else {
                  this.defaultPayload.noteToCandidate = config?.notes?.note_to_candidate || '';
                  this.defaultPayload.noteToReferee = config?.notes?.note_to_referee || '';
                  this.defaultNotes = {
                    noteToCandidate: config?.notes?.note_to_candidate || '',
                    noteToReferee: config?.notes?.note_to_referee || ''
                  };
                }
            }

            if (this.checkType === ConstantsService.REFERENCE_CHECK) {
                this.criteriaID = this.questionnaireSelected?.questionnaire?.third_party_questionnaire_id?.criteria;
            }
            this.messages = this.messages.filter(val => {
                return val.key !== 'package'
              });
            this.updateSendButton();
            this.questionnaireButtonText = $localize`Replace survey`
          }
        },
        (error) => {
          console.error('Error loading questionnaire:', error);
        }
      );
    } else {
      // No reference config - reset to default values
      this.questionnaireSelected = null;
      this.questionnaireButtonText = $localize`Select survey`;

      // Reset defaultPayload to default values with org notes
      const orgNotes = (this.org && this.org['notes']) ? this.org['notes'] : { note_to_candidate: '', note_to_referee: '' };
      this.defaultPayload = {
        ...this.defaultPayload,
        referenceCount: 2,
        coverageCount: 2,
        timeGap: 4,
        selectedTimeGapPeriod: 'Weeks',
        allowTimeGaps: false,
        noteToCandidate: '',
        noteToReferee: '',
        coverageCountAdded: false
      };

      // Reset defaultNotes to org notes
      this.defaultNotes = {
        noteToCandidate: orgNotes.note_to_candidate || '',
        noteToReferee: orgNotes.note_to_referee || ''
      };

      // Clear criteria ID if it was set
      if (this.checkType === ConstantsService.REFERENCE_CHECK) {
        this.criteriaID = 0;
      }

      this.updateSendButton();
    }
  }
  private processSingleTemplate(template: any): any {
    // Find the background config block
    const backgroundConfig = template.config?.find(c => c.type === 'background');

    // Extract partner check names from partner_checks array
    const backgroundChecks = backgroundConfig?.partner_checks
      ?.map((check: any) => check.name)
      .join(', ') || '';

    // Find the reference config block
    const referenceConfig = template.config?.find(c => c.type === 'reference');

    // Extract package_name (if present)
    const request = referenceConfig?.package_name || '';

    // Format created date to "22 Sept 2025" format
    const created = this.formatDate(template.created);

    // Format last_used date to "22 Sept 2025" format
    const last_used = this.formatDate(template.last_used);

    // Add a new property to your template object
    return {
      ...template,
      backgroundChecks,
      request,
      created,
      last_used
    };
  }

  private formatDate(date: string | null | undefined): string | null {
    if (!date) {
      return null;
    }
    // Format date from "YYYY-MM-DD" to "D MMM YYYY" (e.g., "22 Sept 2025")
    return moment(date, 'YYYY-MM-DD').format('D MMM YYYY');
  }

  getBackgroundCheckTooltip() {
    if (!this.hasBackgroundCheckPermissions) {
      return $localize`To enable background checks, you must first connect to Trust Marketplace within the organisation settings.`
    } else if (this.hasBackgroundCheckPermissions && !this.canSendBackgroundRequest) {
      return this.backgroundRequestTooltip
    } else if (this.hasBackgroundCheckPermissions && this.canSendBackgroundRequest) {
      return '';
    }
    return ''
  }

  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustStatus$.subscribe(status_code => {
      this.hasBackgroundCheckPermissions = status_code === 3;
      this.backgroundCheckTooltip = this.hasBackgroundCheckPermissions ? '' : this.backgroundCheckTooltip

      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
    this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
      res => {
        if (res != undefined) {
          this.tmpAdminStatus = res;
        }
      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
  }


  @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      //At bottom of page
      this.ngZone.run(() => {
        this.attachToFooter = true
      })
    } else if ((window.innerHeight + window.scrollY) < (document.body.offsetHeight - 100) || window.scrollY == 0) {
      // No longer at bottom of page
      this.ngZone.run(() => {
        this.attachToFooter = false
      })
    }
  }

    retrieveAvailableBackgroundChecks(checkName = '') {
    if (checkName){
      this.requestService.getEnhancedBackgroundChecksList([checkName]).subscribe((data: any) => {
        this.requestService.updateBackgroundChecksSubject(data);
      },
      (error: any) => {
        console.log("error", error)
      })
    }
  }

  ngOnInit(): void {
    this.ent_11525_unlock_xref_me = this.permissions.isFeatureActivated('ent-11525-unlock-xref-me');
    this.ent_10781_signup_improvements = this.permissions.isFeatureActivated('ent-10781-signup-improvements');
    if (this.ent_10781_signup_improvements) {
      this.isTrialUser = this.planService.planState.is_non_cb_trial;
    }
    this.loading = true;
    this.backgroundCheckTooltip = $localize`To enable background checks, you must first connect to Trust Marketplace within the organisation settings.`
    this.fetchTrustMarketplaceStatus()
    this.editingRequest = getParam('check_uid') != '';

    this.hasBulkUploadPermissions = this.permissions.isOrgFeatureEnabled('csv_upload');
    if(!this.hasBulkUploadPermissions){
      this.bulkUploadTooltipText = $localize`Upgrade to enable this feature. Click to request access.`
    }


    this.backgroundCheckTooltip = $localize`To enable background checks, you must connect to Trust Marketplace via organisation settings.`

    this.initializeRequestPermissionsAndTooltips();
    forkJoin({
      orgDetails: this.organisationService.getOrganisation(),
      orgDepartments: this.organisationService.getAllDetailedDepartments()
    }).subscribe(({orgDetails, orgDepartments}) => {
      this.org = orgDetails;
      this.org["departments"] = orgDepartments?.departments?.filter(dept => !dept['disabled']);
      this.defaultPayload["noteToCandidate"] = orgDetails.notes.note_to_candidate;
      this.defaultPayload["noteToReferee"] = orgDetails.notes.note_to_referee;
      this.loading = false;
      this.resetToDefault()
      if (this.checkType === ConstantsService.EXIT_CHECK || this.checkType === ConstantsService.PULSE_CHECK) this.isDomainAndDepartmentConfigured()
      if(this.selectedTemplate){
          this.selectedTemplate = this.processSingleTemplate(this.selectedTemplate);
          this.loadTemplateData();
      }
    });

    if (this.canSendBackgroundRequest) {
      this.retrieveAvailableBackgroundChecks();
    }


    if(this.canSendBackgroundRequest){
      this.checksLoading = true;
      this.bgCheckService.getBackgroundChecks();

      this.bgCheckService.bgChecks.subscribe(checks => {
        this.backgroundChecksData = checks;
        this.backgroundChecksList = checks['categorizedChecks'];
        this.checksLoading = false;
        if(this.selectedTemplate){
            const background_config = this.selectedTemplate?.config?.find((c: any) => c.type === 'background');
            if(background_config?.partner_checks){
                this.loadTemplateBGC(background_config);
            }
        }
      })
    }

    this.disableRecipientListButtons = this.checkType === this.backgroundCheck;

    if (localStorage.getItem('draft_uid') || this.checkType === ConstantsService.EXIT_CHECK) {
      this.checkType = ConstantsService.EXIT_CHECK;
      this.draftUid = localStorage.getItem('draft_uid');
      if (this.draftUid) {
        this.retrieveRecipientTableData();
      }
    } else if (localStorage.getItem('draft_reference_uid') || this.checkType === ConstantsService.REFERENCE_CHECK) {
      this.checkType = ConstantsService.REFERENCE_CHECK;
      this.draftReferenceUid = localStorage.getItem('draft_reference_uid');
      if (this.draftReferenceUid) {
        this.retrieveReferenceRecipientTableData();
      }
    } else if ((localStorage.getItem('draft_background_check_uid') || this.checkType === ConstantsService.BACKGROUND_CHECK)) {
      this.checkType = ConstantsService.BACKGROUND_CHECK;
      this.draftReferenceUid = localStorage.getItem('draft_background_check_uid');
      this.bgCheckService.bgChecks.subscribe(checks => {
        if (this.draftReferenceUid) {
          this.retrieveBackgroundCheckRecipientTableData();
          this.updateSendButton();
        }
      })
    } else if (localStorage.getItem('draft_pulse_uid') || this.checkType === ConstantsService.PULSE_CHECK) {
      this.checkType = ConstantsService.PULSE_CHECK;
      this.draftPulseUid = localStorage.getItem('draft_pulse_uid');
      this.draftReferenceUid = localStorage.getItem('draft_pulse_uid');
      if (this.draftReferenceUid) {
        this.retrievePulseRecipientTableData();
      }
    } else {
      setPageDirtyFlag(false);
    }

    if (this.preFill) {
      this.peopleService.selectedPeople.forEach(person => {
          if (person?.disable_replace){
            this.disable_replace = person.disable_replace
          if (person['person_email_list']?.length) {
            person['person_email_list'].forEach(email => {
              let e = email[1] == 0 ? 'work_email': 'personal_email';
              person[e] = email[0];
            })
          }
          else {
            person['personal_email'] = person['email'];
          }
        }
        else{
          if (person['person_email_list'].length) {
            person['person_email_list'].forEach(email => {
              let e = email[1] == 0 ? 'work_email': 'personal_email';
              person[e] = email[0];
            })
          }
          else {
            person['personal_email'] = person['email'];
          }
        }

      })
      this.recipients = this.peopleService.selectedPeople;
      if (this.checkType == this.exitCheck) {
        this.addRecipientDetails();
      } else if (this.checkType == this.referenceCheck) {
        this.addReferenceRecipientDetails();
      } else if (this.checkType == this.pulseCheck) {
        this.addPulseRecipientDetails();
      } else if (this.checkType == this.backgroundCheck) {
        this.bgCheckService.bgChecks
        .pipe(
          filter(checks => Object.keys(checks).length > 0),
          take(1)
        )
        .subscribe(checks => {
          this.shouldOpenSelectCheckModal = true;
          this.showSelectBackgroundCheckModal();
        });
      }
    }


    this.planService.getSFDCid().subscribe(
      res=>{
        this.sfcdId=res?.data?.sf_account
      },
      err=>{
        console.log(err)
      }
      )


    if (getParam('check_uid')) {
      this.requestService.getDraftCheckDetails(getParam('check_uid')).subscribe(
        (res: any) => {
            this.isScheduleDateTimeSet = true;
            if (res.data.omni_check.scheduled_time) {
              const timezone = res.data.omni_check.scheduled_timezone
              const scheduleTime = moment(res.data.omni_check.scheduled_time).tz(timezone)
              const scheduled_date = scheduleTime.format('DD/MM/YYYY')
              const scheduled_time = scheduleTime.format('hh:mm A')
              this.scheduleExpiry.date = scheduled_date
              this.scheduleExpiry.time = scheduled_time
              this.scheduleExpiry.timeZone = timezone
              this.isFirstOpen = true;
              this.isScheduleDateTimeSet = true;
            }
            if (res.data.omni_check.expiry) {
              const timeZone = res.data.omni_check.scheduled_timezone
              const cuttOfftime = moment(res.data.omni_check.expiry).tz(timeZone)
              const expiry_date = cuttOfftime.format('DD/MM/YYYY')
              const expiry_time = cuttOfftime.format('hh:mm A')
              this.cutOffExpiry.date = expiry_date
              this.cutOffExpiry.time = expiry_time
              this.cutOffExpiry.timeZone = timeZone
              this.editPulseCustomised = true;
            }
            localStorage.setItem('draft_pulse_uid', res.data['uid'])
            this.draftPulseUid = res.data['uid']
            this.retrievePulseRecipientTableData()
            this.questionnaireSelected = res.data.package
            this.questionnaireIdSelected = res.data.package.id

            if (this.questionnaireIdSelected) {
              this.questionnaireButtonText = $localize`Replace survey`
            }
          }
        )
    }
      this.clearDraftServiceSubscription = this.clearDraftService.componentMethodCalled$.subscribe(() => {
        this.clearDraft();
      });
  }

  loadTemplateBGC(background_config){
    // Map partner_checks to selectedBackgroundChecks and flowsSelected

    // Always reset first so a previously selected package's API settings cannot
    // leak into the recipient modal, then only repopulate behind the flag.
    this.packageApiSettings = {};
    if (this.permissions.isFeatureActivated('xref-api-v1')) {
      this.packageApiSettings = background_config.additional_details || {};
    }

    background_config.partner_checks.forEach((partnerCheck: any) => {
        // Find matching check from backgroundChecksList by short_name
        const matchedCheck = this.backgroundChecksList?.find(
            (check: any) => check.short_name === partnerCheck.short_name
        );

        if (matchedCheck) {
            // Add the full check object to selectedBackgroundChecks
            this.selectedBackgroundChecks.push(matchedCheck);

            // If the partner check has a flow_name, find and add the matching flow
            if (partnerCheck.flow_name && matchedCheck.flow_names) {
                const matchedFlow = matchedCheck.flow_names.find(
                    (flow: any) => flow.short_name === partnerCheck.flow_name
                );
                if (matchedFlow) {
                    this.flowsSelected.push({
                        ...matchedFlow,
                        parent_short: matchedCheck.short_name
                    });
                }
            }
        }
    });

    // Update related properties
    this.selectedBackgroundChecksIds = this.selectedBackgroundChecks.map((check: any) => check.uid);
    this.bgCheckShortNames = this.selectedBackgroundChecks.map((check: any) => check.short_name);
    this.disableRecipientListButtons = this.selectedBackgroundChecks.length === 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateSendButton();
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  initializeRequestPermissionsAndTooltips() {
    this.canSendReferenceRequest = this.permissions.hasPermission('can_send_reference_requests') || this.permissions.hasPermission('can_send_reference_requests_with_survey_perms')
    this.canSendPulseRequest = this.permissions.hasPermission('can_send_pulse_requests') || this.permissions.hasPermission('can_send_pulse_requests_with_survey_perms')
    this.canSendExitRequest = this.permissions.hasPermission('can_send_exit_requests') || this.permissions.hasPermission('can_send_exit_requests_with_survey_perms')
    this.canSendBackgroundRequest = this.permissions.hasPermission('can_send_backgroundcheck_requests')


    this.canManageTemplate = this.permissions.hasPermission("can_manage_package")
    this.backgroundMember = this.permissions.hasPermission("can_view_use_backgroundcheck_package")
    this.referenceMember = this.permissions.hasPermission("can_view_use_reference_package_with_survey_permission")
    this.backgroundAdmin = this.permissions.hasPermission("can_manage_backgroundcheck_package")
    this.referenceAdmin = this.permissions.hasPermission("can_manage_reference_package")
    this.referenceRequestTooltip = !this.canSendReferenceRequest ? ConstantsService.REFERENCE_NONE_TOOLTIP : '';
    this.pulseRequestTooltip = !this.canSendPulseRequest ? ConstantsService.PULSE_CHECK_NONE_TOOLTIP : '';
    this.exitRequestTooltip = !this.canSendExitRequest ? ConstantsService.EXIT_CHECK_NONE_TOOLTIP : '';
    this.backgroundRequestTooltip = !this.canSendBackgroundRequest ? ConstantsService.BACKGROUND_CHECK_NONE_TOOLTIP : '';
  }

  isTrialCapReached(): boolean {
    if (!this.ent_10781_signup_improvements) return false;
    return this.planService.isTrialCreditsExhausted();
  }

  selectCheckType(check) {
    if ((check === ConstantsService.REFERENCE_CHECK || check === ConstantsService.EXIT_CHECK) && this.isTrialCapReached()) {
      this.bsModalRef = this.modalService.show(LockedFeatureModalComponent, {
        class: 'modal-dialog-centered',
        initialState: { variant: 'request-cap' as const }
      });
      return;
    }

    if ((!this.hasBackgroundCheckPermissions || !this.canSendBackgroundRequest) && check === this.backgroundCheck) return

    if (check === ConstantsService.EXIT_CHECK) {
      if (!this.canSendExitRequest) return
      this.isDomainAndDepartmentConfigured()
      if (localStorage.getItem('draft_uid')) {
        this.retrieveRecipientTableData();
        this.checkType = check;
      }
      else if (localStorage.getItem('draft_reference_uid') || localStorage.getItem('draft_pulse_uid')) {
        this.showWarningModal(check);
      }
      // TODO: During FF removal, append this condition with checking draft uids
      else if ((this.backgroundCheckIdSelected || localStorage.getItem('draft_background_check_uid'))) {
        this.showWarningModal(check);
      } else {
        this.checkType = check;
        this.resetVariables();
      }
    }
    else if (check === ConstantsService.REFERENCE_CHECK) {
      if (!this.canSendReferenceRequest) return
      if (localStorage.getItem('draft_reference_uid')) {
        this.retrieveReferenceRecipientTableData();
        this.checkType = check;
      } else if (localStorage.getItem('draft_uid') || localStorage.getItem('draft_pulse_uid')) {
        this.showWarningModal(check);
      }
      // TODO: During FF removal, append this condition with checking draft uids
      else if ((this.backgroundCheckIdSelected || localStorage.getItem('draft_background_check_uid'))) {
        this.showWarningModal(check);
      }
      else {
        this.checkType = check;
        this.resetVariables();
      }
    }
    else if (check === ConstantsService.PULSE_CHECK) {
      if (!this.canSendPulseRequest) return

      this.isDomainAndDepartmentConfigured()
      if (localStorage.getItem('draft_pulse_uid')) {
        this.retrievePulseRecipientTableData();
        this.checkType = check;
      } else if (localStorage.getItem('draft_uid') || localStorage.getItem('draft_reference_uid')) {
        this.showWarningModal(check);
      }
      // TODO: During FF removal, append this condition with checking draft uids
      else if ((this.backgroundCheckIdSelected || localStorage.getItem('draft_background_check_uid'))) {
        this.showWarningModal(check);
      }
      else {
        this.checkType = check;
        this.resetVariables();
      }
    }
    else if (check === ConstantsService.BACKGROUND_CHECK) {
      if (localStorage.getItem('draft_background_check_uid')){
        this.retrieveBackgroundCheckRecipientTableData();
        this.checkType = check;
      } else if (localStorage.getItem('draft_uid') || localStorage.getItem('draft_pulse_uid') || localStorage.getItem('draft_reference_uid')) {
        this.showWarningModal(check);
      } else {
        this.checkType = check;
        this.resetVariables();
      }
    }
  }

  showWarningModal(check) {
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered',
      initialState: {
        "title": $localize`Change request type?`,
        "message": $localize`All information you have entered will be lost.\n\nAre you sure you want to continue?`
      }
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.checkType = check;
        if (check == ConstantsService.REFERENCE_CHECK) {
          localStorage.removeItem('draft_uid');
          localStorage.removeItem('draft_pulse_uid');
          localStorage.removeItem('draft_background_check_uid')
        }
        if (check == ConstantsService.EXIT_CHECK) {
          localStorage.removeItem('draft_reference_uid');
          localStorage.removeItem('draft_pulse_uid');
          localStorage.removeItem('draft_background_check_uid')
        }
        if (check == ConstantsService.PULSE_CHECK) {
          localStorage.removeItem('draft_reference_uid');
          localStorage.removeItem('draft_uid');
          localStorage.removeItem('draft_background_check_uid')

        }
        if (check == ConstantsService.BACKGROUND_CHECK) {
          localStorage.removeItem('draft_reference_uid');
          localStorage.removeItem('draft_pulse_uid');
          localStorage.removeItem('draft_uid');
        }
        this.resetVariables();
      }
    });
  }

  isDomainAndDepartmentConfigured(){
    if (this.org['departments'].length < 4 || this.org['domains'].length < 1) {
      this.disableSection = true
    }
    else {
      this.disableSection = false
    }
  }

  resetVariables() {

    this.questionnaireSelected = '';
    this.questionnaireList = [];
    this.recipients = {};
    this.updatedTemplates = [];
    this.templates = [];
    this.filterRecipients = '';
    this.total = 0;
    this.countOfRecipientsWithoutMobile = 0;
    this.templateVariables = [];
    this.questionnaireIdSelected = 0;
    this.questionnaireButtonText = $localize`Select survey`;
    this.sendRequestButton = $localize`Send request`
    this.defaultLogo = ConstantsService.DEFAULT_LOGO;
    this.draftUid = '';
    this.draftReferenceUid = '';
    this.draftBackgroundCheckUid = '';
    this.draftPulseUid = '';
    this.disableSend = true;
    this.draftResponse = {};
    this.errorCount = 0;
    this.warningCount = 0;
    this.criteria = false;
    this.bulkSendAvailable = true;
    this.messages = [];
    this.attachToFooter = false;
    this.isCutoffCustomised = false
    this.isFirstOpen = false
    this.isScheduleDateTimeSet = false
    this.isScheduleDateTimeInPast = false
    this.isReceipentUptoLimit = false
    this.disableRecipientListButtons = this.checkType != this.backgroundCheck ? false : true;
    this.backgroundCheckButtonText = $localize`Add checks`
    this.backgroundCheckSelected = {}
    this.backgroundCheckIdSelected = 0;
    this.flowSelected = {}
    this.flowsSelected = []

  }

  updateErrorCount(error) {
    this.errorCount = error['error'];
    this.warningCount = error['warning']
    this.updateFilterCount();
    this.updateSendButton();
  }

  updateinValidRecipients(error) {
    this.inValidRecipients = error
  }

  updateFilter(filter) {
    this.filterBy = filter;
    this.updateFilterCount();
  }

  totalExternalChecks(totalChecks){
    this.totalCheck = totalChecks
  }

  updateFilterCount() {
    this.filterCount = 0;
    if(this.filterBy.error) {
      this.filterCount += this.errorCount;
    }
    if(this.filterBy.warning) {
      this.filterCount += this.warningCount;
    }
  }

  updateSendButton() {
    let messageCount = this.messages.filter(val => val['type'] === "danger").length;
    const isReceipentValid = this.checkType === ConstantsService.PULSE_CHECK ? this.total >= 5 : this.total > 0;
    if (this.questionnaireSelected){
      this.disableSend = !(isReceipentValid &&
        Object.keys(this.questionnaireSelected).length !== 0 &&
        messageCount === 0 && this.errorCount === 0);
    }
    else if(this.selectedTemplate){
        const referenceConfig = this.selectedTemplate.config?.find((c: any) => c.type === 'reference');
        if(!referenceConfig){
            this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.selectedBackgroundChecks.length > 0 && this.hasBackgroundCheckPermissions);
        }
        else {
            if(this.questionnaireSelected) {
                this.disableSend = !(isReceipentValid && Object.keys(this.questionnaireSelected).length !== 0 && messageCount === 0 && this.errorCount === 0);
            }
            else {
                const bcgConfig = this.selectedTemplate.config?.find((c: any) => c.type === 'background');
                if(!bcgConfig){
                    if(this.selectedBackgroundChecks.length <= 0){
                        this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.hasBackgroundCheckPermissions && !this.inValidRecipients);
                    }
                    else{
                        this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.selectedBackgroundChecks.length > 0 && this.hasBackgroundCheckPermissions);
                    }
                }
                else {
                    if(this.selectedBackgroundChecks.length <= 0){
                        this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.hasBackgroundCheckPermissions && !this.inValidRecipients);
                    }
                    else{
                        this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.selectedBackgroundChecks.length > 0 && this.hasBackgroundCheckPermissions);
                    }
                }
            }
        }
    }
    this.displayWarning();
    if (this.checkType === ConstantsService.REFERENCE_CHECK){
      if (this.questionnaireSelected?.config?.min_referee &&  this.questionnaireSelected?.config?.min_referee <= 5){
        let refCount = this.questionnaireSelected?.config?.min_referee || 0;
        refCount = this.defaultPayload.referenceCount || refCount;
        this.defaultPayload = {
          ...this.defaultPayload,
          referenceCount: refCount
        };
      }
    }
    if (this.checkType === ConstantsService.PULSE_CHECK) {
      // Toggle Button
      this.sendRequestButton = this.isScheduleDateTimeSet ? $localize`Schedule request` : $localize`Send request`
      // Is Scheduled Date in past
      this.isScheduleDateTimeInPast = this.isScheduleDateTimeBeforeCurrentTime()
      // Disable send button
      if (this.isScheduleDateTimeInPast) {
        this.disableSend = true
        this.isScheduleDateTimeInPast = true
        this.isReceipentUptoLimit = false
      }
      else if (this.total > 0 && this.total < 5) {
        this.isReceipentUptoLimit = true
        this.isScheduleDateTimeInPast = false
      } else {
        this.isReceipentUptoLimit = false
        this.isScheduleDateTimeInPast = false
      }
    }
    if (this.checkType === ConstantsService.BACKGROUND_CHECK)
      this.disableSend = !(isReceipentValid && messageCount === 0 && this.errorCount === 0 && this.selectedBackgroundChecks.length > 0 && this.hasBackgroundCheckPermissions);
  }

  showBulkUploadModal() {
    if (this.isTrialUser) {
      this.bsModalRef = this.modalService.show(LockedFeatureModalComponent, {
        class: 'modal-dialog-centered',
        initialState: { variant: 'feature-locked' as const }
      });
      return;
    }

    if (!this.hasBulkUploadPermissions) {
      // if user or org is not allowed to upload Bulk CSV recipients file,
      // then user is redirected to page of Contact account manager
      window.open(ConstantsService.CONTACT_US, "_blank");
      return;
    }

    if (!this.hasProductPermission()) {
      return
    }
    let initialState = {
      "checkType": this.checkType
    };
    if (this.checkType === this.backgroundCheck) {
      initialState["selectedBackgroundCheck"] = this.selectedBackgroundChecks[0];
    }

    if(this.checkType === this.backgroundCheck)
    {
        initialState["selectedFlow"] = this.flowsSelected[0];
    }
    this.bsModalRef = this.modalService.show(XrefBulkUploadModalComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.bulkRequestData.subscribe(res => {
      this.total = res['total'];
    })
  }

  hasProductPermission(){
    switch (this.checkType) {
      case ConstantsService.REFERENCE_CHECK:
          if(this.selectedTemplate){
              if(this.canManageTemplate){
                  return this.canManageTemplate
              }
              const referenceConfig = this.selectedTemplate.config?.find((c: any) => c.type === 'reference');
              const background_config = this.selectedTemplate?.config?.find((c: any) => c.type === 'background');
              if(referenceConfig && (this.referenceAdmin || this.referenceMember)){
                  return this.referenceAdmin || this.referenceMember
              }
              else if(background_config && (this.backgroundAdmin || this.backgroundMember)){
                  return this.backgroundAdmin || this.backgroundMember
              }
          }
        return this.canSendReferenceRequest;
      case ConstantsService.PULSE_CHECK:
        return this.canSendPulseRequest;
      case ConstantsService.EXIT_CHECK:
        return this.canSendExitRequest
      case ConstantsService.BACKGROUND_CHECK:
        return this.canSendBackgroundRequest;
      default:
        return false;
    }
  }

  showAddRecipientModal() {
    if (!this.hasProductPermission()) {
      return
    }
    let initialState = {
      "total": this.total,
      ...({
            countryItems: cloneDeep(ConstantsService.COUNTRY_ALPHA_CODES)
          })
    }
    if (this.permissions.isFeatureActivated('xref-api-v1')) {
      initialState['packageApiSettings'] = this.packageApiSettings;
    }
    if (this.checkType === ConstantsService.EXIT_CHECK) {
      this.bsModalRef = this.modalService.show(XrefAddRecipientModalComponent, {
        class: 'modal-dialog-centered', initialState
      });
      this.bsModalRef.content.nextClick.subscribe(payload => {
        this.recipients = payload['data'];
        this.loading = true;
        if (localStorage.getItem('draft_uid')) {
          this.addExitToDraft(payload['data']);
        } else {
          this.addRecipientDetails();
        }
      })
    } else if (this.checkType === ConstantsService.REFERENCE_CHECK) {
      if(this.selectedTemplate){
          initialState['backgroundChecks'] = this.selectedBackgroundChecks;
          initialState['flowsSelected'] = this.flowsSelected;
          initialState['template'] = this.selectedTemplate.config?.find((c: any) => c.type === 'reference') && this.questionnaireSelected;
          this.bsModalRef = this.modalService.show(AddRecipientBackgroundCheckModalComponent, {
            class: 'modal-dialog-centered', initialState
          });
          this.bsModalRef.content.nextClick.subscribe(payload => {
            this.loading = true;
            this.recipients = payload['data'];
            if(payload['data']?.internal_reference && this.bgCheckShortNames.length>0 && !this.bgCheckShortNames.includes('xref_open_api')){
                if (!this.bgCheckShortNames.includes('xref_open_api')) {
                    this.bgCheckShortNames.push('xref_open_api');
                }
            }
            if (localStorage.getItem('draft_reference_uid')) {
              this.addReferenceToDraft(payload['data']);

            } else {
              this.addReferenceRecipientDetails();
            }
            this.updateSendButton();
          })
      }
      else {
          this.bsModalRef = this.modalService.show(XrefAddReferenceRecipientModalComponent, {
              class: 'modal-dialog-centered', initialState
          });
          this.bsModalRef.content.nextClick.subscribe(payload => {
              this.loading = true;
              this.recipients = payload['data'];
              if (localStorage.getItem('draft_reference_uid')) {
                  this.addReferenceToDraft(payload['data']);
              } else {
                  this.addReferenceRecipientDetails();
              }
          })
      }
    } else if (this.checkType === ConstantsService.PULSE_CHECK) {
      this.bsModalRef = this.modalService.show(XrefAddPulseRecipientModalComponent, {
        class: 'modal-dialog-centered', initialState
      });
      this.bsModalRef.content.nextClick.subscribe(payload => {
        this.loading = true;
        this.recipients = payload['data'];
        if (localStorage.getItem('draft_pulse_uid')) {
          this.addPulseToDraft(payload['data']);
        } else {
          this.addPulseRecipientDetails();
        }
      })
    } else if (this.checkType === ConstantsService.BACKGROUND_CHECK) {
      initialState['backgroundChecks'] = this.selectedBackgroundChecks;

      initialState['flowsSelected'] = this.flowsSelected;

      this.bsModalRef = this.modalService.show(AddRecipientBackgroundCheckModalComponent, {
        class: 'modal-dialog-centered', initialState
      });
      this.bsModalRef.content.nextClick.subscribe(payload => {
        this.loading = true;
        this.recipients = payload['data'];
        if (localStorage.getItem('draft_background_check_uid')) {
          this.addBackgroundCheckToDraft(payload['data']);

        } else {
          this.addBackgroundCheckRecipientDetails();
        }
      })
    }
  }

  isReference(){
      if(this.selectedTemplate) {
          return !!this.questionnaireSelected && Object.keys(this.questionnaireSelected).length > 0;
      }
      else{
          return true
      }
  }

  clearDraft() {
    if (this.checkType === ConstantsService.EXIT_CHECK) this.clearDraftUid();
    if (this.checkType === ConstantsService.REFERENCE_CHECK) this.clearReferenceDraftUid();
    if (this.checkType === ConstantsService.PULSE_CHECK) this.clearPulseDraftUid();
    if (this.checkType === ConstantsService.BACKGROUND_CHECK) this.clearBackgroundCheckDraftUid();
  }

  clearDraftUid() {
    let exit_uid = localStorage.getItem('draft_uid')
    if (exit_uid) {
      this.requestService.removeDraft(exit_uid).subscribe((data: any) => {
        this.draftUid = '';
        this.total = 0;
        this.updateSendButton();
        localStorage.removeItem('draft_uid');
        this.bsModalRefShowAll.content.onClear();
        },
        (err: any) => {
          console.log(err)
      })
      }
  }

  clearReferenceDraftUid() {
      let reference_uid = localStorage.getItem('draft_reference_uid')
      if (reference_uid) {
        this.requestService.removeDraftBackgroundCheck(reference_uid).subscribe((data: any) => {
        this.draftReferenceUid = '';
        this.total = 0;
        this.updateSendButton();
        localStorage.removeItem('draft_reference_uid');
        this.bsModalRefShowAll.content.onClear();
      },
        (err: any) => {
            console.log(err)
        })
      }
  }

  clearBackgroundCheckDraftUid() {
    if(localStorage.getItem('draft_background_check_uid')){
      this.requestService.removeDraftBackgroundCheck(localStorage.getItem('draft_background_check_uid')).subscribe((data: any) => {
          this.draftBackgroundCheckUid = '';
          this.total = 0;
          this.updateSendButton();
          localStorage.removeItem('draft_background_check_uid');
          this.bsModalRefShowAll?.content.onClear();
        },
        (err: any) => {
            console.log(err)
        })
    }
  }

  clearPulseDraftUid() {
    let draft_uid = localStorage.getItem('draft_pulse_uid')
    if (draft_uid) {
      this.requestService.removeDraftPulse(draft_uid).subscribe((data: any) => {
        this.draftPulseUid = '';
        this.total = 0;
        this.updateSendButton();
        localStorage.removeItem('draft_pulse_uid');
        this.bsModalRefShowAll.content.onClear();
        },
        (err: any) => {
          console.log(err);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
        })
    }
  }

  addExitToDraft(recipient) {
    this.requestService.appendExit(recipient, localStorage.getItem('draft_uid')).subscribe((data: any) => {
      this.total = data['total_exits'];
      this.loading = false;
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addReferenceToDraft(recipient) {
    let shortNames = undefined
    let isExternalCheck = false
    if(this.selectedTemplate && this.bgCheckShortNames.length>0){
        shortNames = this.bgCheckShortNames
        isExternalCheck = true
    }
    this.requestService.appendBackgroundCheck(
      recipient, localStorage.getItem('draft_reference_uid'),
      shortNames, isExternalCheck
    ).subscribe((data: any) => {
        this.total = data['total_external_checks'];
        this.loading = false;
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addBackgroundCheckToDraft(recipient) {
    let shortNames: any;
    shortNames = this.bgCheckShortNames

    this.requestService.appendBackgroundCheck(
      recipient,
      localStorage.getItem('draft_background_check_uid'),
      shortNames
    ).subscribe((data: any) => {
      this.total = data['total_external_checks'];
      this.loading = false;
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addPulseToDraft(recipient) {
    this.requestService.appendPulse(recipient, localStorage.getItem('draft_pulse_uid')).subscribe((data: any) => {
      this.total = data['total_pulses'];
      this.loading = false;
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! The recipient details you have entered contain errors and have not been saved.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addRecipientDetails() {
    this.requestService.createExit(this.recipients).subscribe((data: any) => {
      this.loading = false;
      this.draftResponse = data;
      this.draftUid = data['draft_uid'];
      if (typeof this.draftUid === "string") {
        localStorage.setItem('draft_uid', this.draftUid);
      }
      this.retrieveRecipientTableData();
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addReferenceRecipientDetails() {
    let shortNames = undefined
    let isExternalCheck = false
    if(this.selectedTemplate && this.bgCheckShortNames.length>0){
        shortNames = this.bgCheckShortNames
        isExternalCheck = true
    }
    this.requestService.createBackgroundCheck(this.recipients, shortNames, isExternalCheck).subscribe((data: any) => {
      this.loading = false;
      this.draftResponse = data;
      this.draftReferenceUid = data['draft_check_uid'];
      if (typeof this.draftReferenceUid === "string") {
        localStorage.setItem('draft_reference_uid', this.draftReferenceUid);
      }
      this.retrieveReferenceRecipientTableData();
    },
    (err: any) => {
      console.log(err);
      this.loading = false;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    })
  }

  addBackgroundCheckRecipientDetails() {
    let shortNames: any;
    shortNames = this.bgCheckShortNames

    this.requestService.createBackgroundCheck(
      this.recipients,
      shortNames
    ).subscribe((data: any) => {
      this.loading = false;
      this.draftResponse = data;
      // TODO: Need to update draft_reference_uid with draft_background_check_uid after background check backend implementation
      this.draftBackgroundCheckUid = data['draft_check_uid'];
      if (typeof this.draftBackgroundCheckUid === "string") {
        localStorage.setItem('draft_background_check_uid', this.draftBackgroundCheckUid);
      }
      this.retrieveBackgroundCheckRecipientTableData();
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  addPulseRecipientDetails() {
    this.requestService.createPulse(this.recipients).subscribe((data: any) => {
      this.loading = false;
      this.draftResponse = data;
      this.draftPulseUid = data['draft_uid'];
      if (typeof this.draftPulseUid === "string") {
        localStorage.setItem('draft_pulse_uid', this.draftPulseUid);
      }
      this.retrievePulseRecipientTableData();
    },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  retrieveRecipientTableData() {
    this.recipientLoader = true;
    this.requestService.retrieveDraftExit(this.draftUid).subscribe((data: any) => {
      this.total = data['total_exits'];
      this.recipientLoader = false;
      if (this.total > 0) {
        this.checkType = ConstantsService.EXIT_CHECK;
      }
      setPageDirtyFlag(this.total > 0);
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_uid')
          this.recipientLoader = false;
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.recipientLoader = false;
        }
      })
  }

  retrievePulseRecipientTableData() {
    this.recipientLoader = !!this.draftPulseUid;

    if (!this.draftPulseUid) {
      return
    }

    this.requestService.retrieveDraftPulse(this.draftPulseUid).subscribe({
      next: (data: any) => {
        this.total = data['total_pulses'];
        this.recipientLoader = false;
        if (this.total > 0) {
          this.checkType = ConstantsService.PULSE_CHECK;
        }
        setPageDirtyFlag(this.total > 0);
      },
      error: (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_pulse_uid');
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
        this.recipientLoader = false;
      }
    });
  }

  getBackgroundCheckType(checkData: any, short_name): string | null {
      if (!checkData || typeof checkData !== 'object' || Object.keys(checkData).filter(k => k !== 'is_deleted').length === 0) {
          // return this.flowNoAddtionalFieldsMapping.short_name;
          const entry = Object.entries(this.flowNoAddtionalFieldsMapping)
            .find(([_, v]) => v === short_name);
          return entry ? entry[0] : null;
      }

      for (const [mappingKey, requiredFields] of Object.entries(this.flowAddtionalFieldsMapping)) {

        const hasAllFields = requiredFields.every(field => field in checkData);
        if (hasAllFields) {
          return mappingKey;
        }
      }

      return null;
    }

  retrieveBackgroundCheckRecipientTableData() {
    this.recipientLoader = true;
    this.requestService.retrieveDraftBackgroundCheck(
      localStorage.getItem('draft_background_check_uid'),'',0,
      0,'','','',
      this.backgroundCheckSelected?.short_name
    ).subscribe((data: any) => {
        const draftChecks = data['external_checks'][0]['checks']
        this.bgCheckShortNames = Object.keys(draftChecks).filter(short_name => !draftChecks[short_name].is_deleted);

        this.selectedBackgroundChecks = this.backgroundChecksList.filter(check => {
          if(check.short_name == 'mobile_id'){
            check.flow_names.forEach(flow => {
              if(this.bgCheckShortNames.includes(flow.short_name)){
                  this.flowSelected = flow;
                  let flowSelect = flow
                  flowSelect['parent_short'] = check.short_name
                  this.flowsSelected.push(flow);
              }
            })
            // In case of mobile id flow selected,
            // we store mobile id obj as selected check instead of flow object
            if(this.flowSelected)
              return true
          }
          else if(check.flow_names && this.bgCheckShortNames.includes(check.short_name)){
              const flowMatched = this.getBackgroundCheckType(draftChecks[check.short_name], check.short_name)
              const index = check.flow_names.findIndex(
                  (flow: any) => flow.short_name === flowMatched
              );
              if (index !== -1) {
                  let flowSelect = check.flow_names[index]
                  flowSelect['parent_short'] = check.short_name
                  this.flowsSelected.push(flowSelect);
              }

              return this.bgCheckShortNames.includes(check.short_name);
          }
          else return this.bgCheckShortNames.includes(check.short_name);
        });

        this.selectedBackgroundChecksIds = this.selectedBackgroundChecks.map(check => check.uid);
        this.disableRecipientListButtons = this.selectedBackgroundChecks.length === 0;

      this.total = data['total_external_checks'];
      this.recipientLoader = false;
      setPageDirtyFlag(this.total > 0);
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_background_check_uid')
          this.recipientLoader = false;
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.recipientLoader = false;
        }
      })
  }

  retrieveReferenceRecipientTableData() {
    this.recipientLoader = true;
    this.requestService.retrieveDraftBackgroundCheck(localStorage.getItem('draft_reference_uid'), '', 0, 0, '', '', [], undefined, false).subscribe((data: any) => {
        this.total = data['total_external_checks'];
        this.totalCheck = data['total_background_checks'];
        this.recipientLoader = false;
        setPageDirtyFlag(this.total > 0);
      },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_reference_uid')
          this.recipientLoader = false;
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
          this.recipientLoader = false;
        }
      })
  }

  updateTotal(data) {
    this.total = data.total;
    if (data.total > 0) {
      this.updateSendButton();
    } else {
      if (this.checkType === ConstantsService.EXIT_CHECK) this.clearDraftUid();
      else if (this.checkType === ConstantsService.REFERENCE_CHECK) this.clearReferenceDraftUid();
      else if (this.checkType === ConstantsService.PULSE_CHECK) this.clearPulseDraftUid();
      else if (this.checkType === ConstantsService.BACKGROUND_CHECK) this.clearBackgroundCheckDraftUid();
    }
    this.updateFilterCount();
  }

  deleteSelection() {

    if(this.selectedTemplate && localStorage.getItem('draft_reference_uid')) {
        this.updateReferenceSelectionInDraft([], ['xref_open_api']).subscribe(
            (data) => {
                this.questionnaireButtonText = $localize`Select survey`
                this.questionnaireSelected = null
                this.updateSendButton();
            }
        )
    }
    else {
        this.questionnaireButtonText = $localize`Select survey`
        this.questionnaireSelected = null
        this.updateSendButton();
    }
  }

  deleteBackgroundCheckSelection() {
    this.clearBackgroundCheckDraftUid();
    this.resetVariables();
    this.updateSendButton();
  }

  removeSelectedCheck(check){
    const updateCheckItems = () => {
      if(check.short_name === 'mobile_id')
        this.flowSelected = {}
      this.selectedBackgroundChecks = this.selectedBackgroundChecks.filter(bgCheck => bgCheck.uid !== check.uid)
      this.flowsSelected = this.flowsSelected.filter(bgCheck => bgCheck.parent_short !== check.short_name)
      this.selectedBackgroundChecksIds = this.selectedBackgroundChecks.map(check => check.uid);
      this.bgCheckShortNames = this.selectedBackgroundChecks.map(check => check.short_name);

      this.disableRecipientListButtons = this.selectedBackgroundChecks.length === 0;
    }

    let draftBackgroundCheckID = localStorage.getItem('draft_background_check_uid')
    if (draftBackgroundCheckID){
      const checkToRemove = check.short_name == 'mobile_id' ? this.flowSelected.short_name : check.short_name
      this.updateBackgroundCheckSelectionsInDraft([], [checkToRemove]).subscribe(
        (data) => {updateCheckItems()}
      )
    }
    else
      updateCheckItems()
  }

  showPlaceholderModal() {
  let initialState = {'variables': this.templateVariables, 'showSMS': true};

    this.bsModalRef = this.modalService.show(EmailSmsPlaceholderModalComponent, {
      class: 'modal-dialog-centered select-survey-new', initialState
    });
}

  showSelectQuestionnaireModal(surveyType) {
    if (!this.hasProductPermission()) {
      return
    }
    let initialState = {"questionnaireList": this.questionnaireList, "surveyType": surveyType}
    this.bsModalRef = this.modalService.show(SelectQuestionnaireModalComponent, {
      class: 'modal-dialog-centered modal-dialog-scrollable modal-lg', initialState
    })
    this.bsModalRef.content.nextClick.subscribe(res => {

      if(this.questionnaireSelected && Object.keys(this.questionnaireSelected).length != 0 && this.checkType === ConstantsService.REFERENCE_CHECK) {

        this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
          class: 'modal-dialog-centered',
          initialState: {
            "title": $localize`Replace the selected survey?`,
            "message": $localize`The request settings will be updated based on the selected survey.\n\nAre you sure you want to continue?`
          }
        });

        this.bsModalRef.content?.selection.subscribe(resWarning => {
          if (resWarning === true) {
            if(this.selectedTemplate && localStorage.getItem('draft_reference_uid')) {
                this.updateReferenceSelectionInDraft(['xref_open_api'], []).subscribe(
                    (data) => {
                        this.updateQuestionnaireSelected(res);
                    }
                  )
            }
            else{
                this.updateQuestionnaireSelected(res);
            }
          }
        });
      }
      else{
        if(this.selectedTemplate && localStorage.getItem('draft_reference_uid')) {
            this.updateReferenceSelectionInDraft(['xref_open_api'], []).subscribe(
                (data) => {
                    this.updateQuestionnaireSelected(res);
                }
              )
        }
        else{
            this.updateQuestionnaireSelected(res);
        }
      }

    })
  }

  updateQuestionnaireSelected(res) {

      this.questionnaireSelected = res['questionnaire'];

      const config = this.questionnaireSelected?.config;
      const default_questionnaire = this.questionnaireSelected?.questionnaire?.is_default;

      this.defaultPayload.referenceCount = config?.min_referee;
      if(default_questionnaire){
        this.defaultPayload.noteToCandidate = this.org['notes']?.note_to_candidate;
        this.defaultPayload.noteToReferee = this.org['notes']?.note_to_referee;
        this.defaultNotes.noteToCandidate = this.org['notes']?.note_to_candidate;
        this.defaultNotes.noteToReferee = this.org['notes']?.note_to_referee;
      }
      else {
        this.defaultPayload.noteToCandidate = config?.notes?.note_to_candidate;
        this.defaultPayload.noteToReferee = config?.notes?.note_to_referee;
        this.defaultNotes.noteToCandidate = config?.notes?.note_to_candidate;
        this.defaultNotes.noteToReferee = config?.notes?.note_to_referee;
      }

      if (this.checkType === ConstantsService.EXIT_CHECK || this.checkType === ConstantsService.PULSE_CHECK) {
        this.questionnaireIdSelected = this.questionnaireSelected['id'];
      }
      if (this.checkType === ConstantsService.REFERENCE_CHECK) {
        this.criteriaID = this.questionnaireSelected['questionnaire']['third_party_questionnaire_id']['criteria'];
      }
      this.messages = this.messages.filter(val => {
        return val.key !== 'package'
      });
      this.updateSendButton();
      this.questionnaireButtonText = $localize`Replace survey`
  }

  showSelectBackgroundCheckModal() {
    if (!this.hasProductPermission()){
      return
    }
      this.bsModalRef = this.modalService.show(SelectBackgroundCheckModalComponent, {
        class: 'modal-dialog-centered xl-popup',
        initialState: {
          backgroundChecks: this.selectedBackgroundChecks,
          backgroundChecksData: this.backgroundChecksData,
          flow: this.flowSelected,
          flows: this.flowsSelected,
        }
      })
      this.bsModalRef.content?.nextClick.subscribe(res => {
        let bgCheckID = localStorage.getItem('draft_background_check_uid')
        if (bgCheckID){
          const newCheckSelections = res?.backgroundCheck
              .filter(check => {
                if (check.flow_names?.length) {
                  // if flow_names exist → see if any flow matches this check
                  const hasMatchingFlow = res.flows.filter(flow =>
                      check.flow_names.some(fn => fn.uid === flow.id)
                    );
                  if (hasMatchingFlow){
                      return !this.selectedBackgroundChecksIds.includes(hasMatchingFlow.id)
                  }
                  return !this.selectedBackgroundChecksIds.includes(check.uid);
                } else {
                  // no flow_names → just use check.uid
                  return !this.selectedBackgroundChecksIds.includes(check.uid);
                }
              })
              .map(check => {
                if (check.short_name === "mobile_id") {
                  const matchedFlow = res.flows.find(flow => flow.parent_short === check.short_name);
                  return matchedFlow ? matchedFlow.short_name : check.short_name;
                } else {
                  return check.short_name;
                }
          });

          const unselectedCheckSelections = this.selectedBackgroundChecks
              .filter(check =>
                !res?.backgroundCheck.includes(check)
              )
              .map(check => {
                  if(check.short_name =='mobile_id'){
                    const matchedFlow = this.flowsSelected.find(
                                      flow => flow.parent_short === check.short_name
                                    );
                    return matchedFlow ? matchedFlow.short_name : check.short_name;
                  }
                const matchedFlow = this.flowsSelected.find(
                  flow => flow.parent_short === check.short_name
                );
                return matchedFlow ? matchedFlow.parent_short : check.short_name;
          });

          const unselectedFlow = this.selectedBackgroundChecks.filter(
            check => check.short_name !== "mobile_id" && !res?.backgroundCheck.includes(check)
          ).map(check => {
                  const matchedFlow = this.flowsSelected.find(flow => flow.parent_short === check.short_name);
                  return matchedFlow ? matchedFlow.short_name : check.short_name;
          })

          const selectedFlows = res?.backgroundCheck
              .filter(check => {
                // 1. skip mobile_id completely
                if (check.short_name === "mobile_id") {
                  return false;
                }

                // 2. skip if no flow_names
                if (!check.flow_names?.length) {
                  return false;
                }

                // 3. only keep if it has at least one matching flow
                const matchedFlows = res.flows.filter(flow =>
                  check.flow_names.some(fn => fn.uid === flow.id)
                );

                return (
                  matchedFlows.length > 0 &&
                  !this.selectedBackgroundChecksIds.includes(matchedFlows[0].id)
                );
              })
              .map(check => {
                const matchedFlow = res.flows.find(
                  flow => flow.parent_short === check.short_name
                );
                return matchedFlow ? matchedFlow.short_name : check.short_name;
          });

          this.updateBackgroundCheckSelectionsInDraft(newCheckSelections, unselectedCheckSelections, selectedFlows,
              unselectedFlow).subscribe(
            (data) => {
              this.selectedBackgroundChecks = res?.backgroundCheck;
              this.flowSelected = res?.flow;
              this.flowsSelected = res?.flows;
              this.disableRecipientListButtons = this.selectedBackgroundChecks.length === 0;

              this.bgCheckShortNames = this.selectedBackgroundChecks.map(check => {
                  if (check.short_name === 'mobile_id') {
                    const matchingFlow = this.flowsSelected.find(flow => flow.parent_short === check.short_name);
                    return matchingFlow ? matchingFlow.short_name : check.short_name;
                  }
                  return check.short_name;
              });
              this.selectedBackgroundChecksIds = this.selectedBackgroundChecks.map(check => {
                  if (check.short_name === 'mobile_id' || check.flow_names?.length) {
                    const matchingFlow = this.flowsSelected.find(flow => flow.parent_short === check.short_name);
                    return matchingFlow ? matchingFlow.id : check.uid;
                  }
                  return check.uid;
              });
            }
          )
        }
        else{
          this.selectedBackgroundChecks = res?.backgroundCheck;
          this.flowSelected = res?.flow;
          this.flowsSelected = res?.flows;
          this.disableRecipientListButtons = this.selectedBackgroundChecks.length === 0;

          this.bgCheckShortNames = this.selectedBackgroundChecks.map(check => {
              if (check.short_name === 'mobile_id') {
                const matchingFlow = this.flowsSelected.find(flow => flow.parent_short === check.short_name);
                return matchingFlow ? matchingFlow.short_name : check.short_name;
              }
              return check.short_name;
          });
          this.selectedBackgroundChecksIds = this.selectedBackgroundChecks.map(check => {
              if (check.short_name === 'mobile_id' || check.flow_names?.length) {
                const matchingFlow = this.flowsSelected.find(flow => flow.parent_short === check.short_name);
                return matchingFlow ? matchingFlow.id : check.uid;
              }
              return check.uid;
          });
        }

        if (this.shouldOpenSelectCheckModal && this.selectedBackgroundChecksIds) {
          this.addBackgroundCheckRecipientDetails();
          if(this.preFill && this.shouldOpenSelectCheckModal){
            this.shouldOpenSelectCheckModal = false;
          }
        }

        this.updateSendButton();
      })
  }

  updateReferenceSelectionInDraft(newChecksShortNames, unselectedChecksShortNames){
      this.recipientLoader = true;
      let checkOperations = {
      'add': newChecksShortNames,
      'remove': unselectedChecksShortNames
    }
      return this.requestService.updateBackgroundChecksDraft(
          null,
          localStorage.getItem('draft_reference_uid'),
          checkOperations
        ).pipe(
          tap((data: any) => {
            this.recipientLoader = false;
          }),
          catchError(err => {
          console.log(err);
          this.recipientLoader = false;
          this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          return throwError(() => err);
        }))
  }
  updateBackgroundCheckSelectionsInDraft(newChecksShortNames:any[]=[], unselectedChecksShortNames:any[]=[],
                                         flowsSelected:any[]=[], flowsUnSelected:any[]=[] ): Observable<any>{
    this.checksLoading = true;
    let checkOperations = {
      'add': newChecksShortNames,
      'remove': unselectedChecksShortNames
    }
    checkOperations['flows_add'] = flowsSelected
    checkOperations['flows_remove'] = flowsUnSelected
    return this.requestService.updateBackgroundChecksDraft(
      null,
      localStorage.getItem('draft_background_check_uid'),
      checkOperations
    ).pipe(
      tap((data: any) => {
        this.total = data['total_external_checks'];
        this.checksLoading = false;
      }),
      catchError(err => {
      console.log(err);
      this.checksLoading = false;
      this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      return throwError(() => err);
    }))

  }

  showReplaceCheckWarningModal(){
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered',
      initialState: {
        "title": $localize`Replace the selected background check?`,
        "message": $localize`All recipient details will be removed.\n\nAre you sure you want to continue?`
      }
    });
    this.bsModalRef.content?.selection.subscribe(res => {
      if (res === true) {
        this.deleteBackgroundCheckSelection();
        setTimeout(() => {
          this.showSelectBackgroundCheckModal();
        }, 500);
      }
    });
  }

  showAllRecipients() {
    let initialState = {
      "typeOfCheck": this.checkType,
      "total": this.total,
      "filterBy": this.filterBy
    };
    if (this.checkType === this.backgroundCheck && this.selectedBackgroundChecks)
      initialState['backgroundChecks'] = this.selectedBackgroundChecks;
      initialState['flowsSelected'] = this.flowsSelected;

    this.bsModalRefShowAll = this.modalService.show(ListRecipientsModalComponent, {
      class: 'modal-dialog-centered modal-dimensions', initialState
    });
    this.bsModalRefShowAll.content.openModal.subscribe(res => {
      if (res === 'open-bulk-request') {
        this.showBulkUploadModal();
      } else if (res === 'open-add-recipient') {
        this.showAddRecipientModal();
      }
    })
    this.bsModalRefShowAll.content.clearDraftFromList.subscribe(res => {
      this.clearDraft();
    })
    this.bsModalRefShowAll.content.updateTotal.subscribe(res => {
      this.updateTotal(res);
    })
    this.bsModalRefShowAll.content.filters.subscribe(res => {
      this.updateFilter(res);
    })
    this.bsModalRefShowAll.content.cancelList.subscribe(res => {
      this.renderComp = res
    })
  }

  setTemplateVariables(templateVariables) {
    this.templateVariables = templateVariables;
  }

  handleSubmitAction(event) {
    if (this.xmeInteractionLocked) {
      return;
    }
    if (!this.hasProductPermission()) {
      return
    }

    if (event === 'submit') {
      if (this.checkType === ConstantsService.EXIT_CHECK) {
        if (this.updatedTemplates.length) this.validate();
        else this.sendRequest();
      } else if (this.checkType === ConstantsService.REFERENCE_CHECK) {
          if(this.selectedTemplate && !this.questionnaireSelected){
              this.sendBackgroundCheck(true);
          }
          else{
              this.sendReferenceRequest();
          }
      } else if (this.checkType === ConstantsService.PULSE_CHECK) {
        if (this.updatedTemplates.length) this.validate();
        else this.sendPulseRequest();
      } else if (this.checkType === ConstantsService.BACKGROUND_CHECK) {
        this.sendBackgroundCheck();
      }
    } else if (event === 'clear') {
        this.router.navigate(['requests']);
    }
  }

  validate() {
    const selectedCheckType = this.checkType === ConstantsService.EXIT_CHECK ? 'exit_request' : 'pulse_request'
    this.organisationService.checkEmailSmsPlaceholders(this.updatedTemplates, selectedCheckType).subscribe((data: any) => {
      this.checkType === ConstantsService.EXIT_CHECK ? this.sendRequest() : this.sendPulseRequest();
    },
      (error: any) => {
        console.log(error);
        for (const [key, value] of Object.entries(error.error['data']['errors'])) {
          let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
          let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
          this.messages = this.messages.concat([{
            'key': key,
            'type': message['type'],
            'message': message['message']
          }]);
        }
        this.updateSendButton();
      })
  }

  updateTemplate(templates) {
    this.templates = templates['templates'];
    if (templates['changed']) {
      this.messages = [];
      this.updateSendButton();
      this.updatedTemplates = templates['templates'];
    }
  }

  displayWarning() {
    this.templates.every(template => {
      if (template['send_sms'] && this.countOfRecipientsWithoutMobile > 0 && !this.disableSend) {
        this.messages = this.messages.concat([{
          'key': 'sms_required',
          'type': 'warning',
          'message': $localize`Please note, only recipients with a mobile phone number will receive an SMS request.`
        }]);
        return false;
      } else {
        let index = this.messages.findIndex(x => x.key === "sms_required");
        if (index !== -1) {
          this.messages = this.messages.filter(function (obj) {
            return obj.key !== 'sms_required';
          });
        }
      }
      return true;
    })
  }

  setCountOfMobileNumbers(count) {
    this.countOfRecipientsWithoutMobile = count;
    this.displayWarning();
  }

  requestSettingsError(error) {
    this.requestSettingsWarning = error
    let messageCount = this.messages.filter(val => val['type'] === "danger").length;
    const isReceipentValid = this.checkType === ConstantsService.PULSE_CHECK ? this.total >= 5 : this.total > 0;
    if (this.questionnaireSelected){
      this.disableSend = !(isReceipentValid &&
        Object.keys(this.questionnaireSelected).length !== 0 &&
        messageCount === 0 && this.errorCount === 0);
    }
    this.displayWarning();
    if (this.checkType === ConstantsService.REFERENCE_CHECK){
      if(!this.disableSend){
        this.disableSend = this.requestSettingsWarning
      }
    }
  }

  requestSettingsData(data) {
    if (data) {
      this.updatedRequestSettings = data
      this.defaultPayload = {
        ...data,
      }
    }
  }

  setOrgName() {
    // Use selected hiring account name if available, otherwise use org brand name
    const name = this.defaultPayload['hiringAccountName'] || this.org['brand_name'];
    return '<span class="org-name">' + name + '</span>';
  }

  sendReferenceRequest() {
    this.retrieveReferenceRecipientTableData()
      if (Object.keys(this.updatedRequestSettings).length == 0) {
        this.updatedRequestSettings = { ...this.defaultPayload };
      }
      const draft_uid = localStorage.getItem('draft_reference_uid');
      const currentUserRole = this.permissions.data.role;

      this.organisationService.getOrganisationRequiredProfileCredit(this.checkType, draft_uid).subscribe(res => {

        let message = '';
        let orgName = this.setOrgName();
        let initialState = {};
        const total_references = this.total
        const total_background_checks =this.totalCheck;

        let referenceMsg = '';
        let backgroundCheckMsg = '';

        this.creditsAllocated = res['profile_credit']['allocated_profile_credits'];
        this.creditsRemaining = res['profile_credit']['remaining_profile_credits'];
        this.creditsUsed = this.creditsAllocated - this.creditsRemaining;

        referenceMsg = (total_references > 1) ? $localize`${total_references} reference requests.` : $localize`${total_references} reference request.`;
        backgroundCheckMsg = (total_background_checks > 1) ? $localize`${total_background_checks} background checks.` : $localize`${total_background_checks} background check.`;

        let contactOwnerText = $localize`To request additional profiles,contact your Xref Account Manager`;
        let contactOwnerHTML = (currentUserRole == 'owner') ? '<span>' + contactOwnerText.split(',')[0] + ',' + '</span> <a href="https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18=' + this.sfcdId + '", target="_blank", rel="noopener noreferrer" class="contact-owner">' + contactOwnerText.split(',')[1] + '</a>.' : '';
        let errorText = (res['profile_credit']['remaining_profile_credits'] < res['required_profile_credit']) ? $localize`Unfortunately, you do not have enough profiles to send this request. <ul class="warning-modal-bullets"><li>Required profiles: ${res['required_profile_credit']}  <li>Profile balance: ${res['profile_credit']['remaining_profile_credits']}</li></ul>${contactOwnerHTML}` : '';

        if(res['profile_credit']['remaining_profile_credits'] < res['required_profile_credit']) {
          errorText = $localize`Unfortunately, your subscription turnover cap is insufficient to send this request. Your turnover cap usage is <span class="weight-500">${this.creditsUsed}/${this.creditsAllocated}</span> and this request would increase the turnover cap usage by <span class="weight-500">${res['required_profile_credit']}</span>.`;
          if (this.permissions.hasPermission('can_view_reference_contact_xref_account_manager')) {
            contactOwnerHTML = '<span>' + this.contactOwnerText.split(',')[0] + ',' + '</span> <a href="https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18=' + this.sfcdId + '", target="_blank", rel="noopener noreferrer" class="contact-owner">' + this.contactOwnerText.split(',')[1] + '</a>.';
            errorText += `<br><br>${contactOwnerHTML}`
          }
        }

        if (total_references > 1) {
          message = $localize`You are sending ${total_references} reference requests on behalf of ${orgName}.`;
        } else {
          message = $localize`You are sending ${total_references} reference request on behalf of ${orgName}.`;
        }
        const disableAgreeCondition =
        res['required_profile_credit'] > res['profile_credit']['remaining_profile_credits'] ||
        (!(total_references || total_background_checks));

        initialState = {
          "title": $localize`Confirm request`,
          "message": message,
          "icon": this.org['logo'] || this.defaultLogo,
          "errorText": errorText,
          "agreeButton": $localize`Send request`,
          "disableAgree": disableAgreeCondition
        };
        let confirmMessage = '';
        confirmMessage = (total_references + total_background_checks > 1) ? $localize`You are sending the following requests on behalf of ${orgName}` : $localize`You are sending the following request on behalf of ${orgName}`;
        confirmMessage = confirmMessage + ':'

        initialState['message'] = confirmMessage;
        initialState['referenceMsg'] = referenceMsg;
        initialState['backgroundCheckMsg'] = backgroundCheckMsg;
        initialState['isOpenedByReference'] = true;
        initialState['referenceWarningMessage'] = $localize`Once a background check has been sent, it cannot be stopped or deleted.`;
        if (total_background_checks == 0) {
          initialState['message'] = message;
          initialState['backgroundCheckMsg'] = undefined;
          initialState['referenceWarningMessage'] = undefined;
        }

        this.bsModalRef = this.modalService.show(WarningModalContentComponent,
          { class: 'modal-dialog-centered warning-modal-dialog', initialState });
        this.bsModalRef.content.selection.subscribe(res => {
          if (res === true) {
            localStorage.setItem('requests-page-selected-tab', 'reference');
            let requestType = 'Reference';
            if(this.totalCheck){
              requestType = 'Multiple Checks'
            }
            this.requestService.sendExternalCheck(localStorage.getItem('draft_reference_uid'), this.criteriaID,
                this.updatedRequestSettings, requestType, this.questionnaireSelected?.id, this.selectedTemplate).subscribe((data: any) => {
                    localStorage.removeItem('draft_reference_uid');

                    this.total = 0;
                    this.updateSendButton();
                    this.messages = [];
                    this.router.navigate(
                        ['requests'],
                        {state: {originPage: 'success'}});
                },
                (error: any) => {
                    console.log(error);
                    for (const [key, value] of Object.entries(error.error['data']['errors'])) {
                        let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
                        let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
                        this.messages = this.messages.concat([{
                            'key': key,
                            'type': message['type'],
                            'message': message['message']
                        }]);
                    }
                    this.updateSendButton();
                })
          }
        })
      });
    }

  sendRequest() {
    let draft_uid = localStorage.getItem('draft_uid');
    const currentUserRole = this.permissions.data.role;
    let message = '';
    let orgName = this.setOrgName();
    this.organisationService.getOrganisationRequiredProfileCredit(this.checkType, draft_uid).subscribe(res => {
      this.creditsAllocated = res['profile_credit']['allocated_profile_credits'];
      this.creditsRemaining = res['profile_credit']['remaining_profile_credits'];
      this.creditsUsed = this.creditsAllocated - this.creditsRemaining;

      let contactOwnerText = $localize`To request additional profiles, contact your Xref Account Manager.`;
      let contactOwnerHTML = (currentUserRole == 'owner') ? '<span>' + contactOwnerText.split(',')[0] + '</span> <a href="https://www.xref.com/support?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18=' + this.sfcdId + '", target="_blank", rel="noopener noreferrer">' + ',' + contactOwnerText.split(',')[1] + '</a>' : '';
      let errorText = (res['profile_credit']['remaining_profile_credits'] < res['required_profile_credit']) ? $localize`Unfortunately, you do not have enough profiles to send this request. <p class="profile">  Required profiles: ${res['required_profile_credit']}\n  Profile balance: ${res['profile_credit']['remaining_profile_credits']}</p>${contactOwnerHTML}` : '';

        if(res['profile_credit']['remaining_profile_credits'] < res['required_profile_credit']) {
          errorText = $localize`Unfortunately, your subscription turnover cap is insufficient to send this request. Your turnover cap usage is <span class="weight-500">${this.creditsUsed}/${this.creditsAllocated}</span> and this request would increase the turnover cap usage by <span class="weight-500">${res['required_profile_credit']}</span>.`;
          if (this.permissions.hasPermission('can_view_exit_contact_xref_account_manager')) {
            contactOwnerHTML = '<span>' + this.contactOwnerText.split(',')[0] + ',' + '</span> <a href="https://www.xref.com/contact-us?src=xref-platform&ltyp=omni&cn=employer-app&uC2C1gdJ18=' + this.sfcdId + '", target="_blank", rel="noopener noreferrer" class="contact-owner">' + this.contactOwnerText.split(',')[1] + '</a>.';
            errorText += `<br><br>${contactOwnerHTML}`
          }
        }

      if (this.total - this.warningCount - res['dnc_count'] > 1) {
        message = $localize`You are sending ${this.total - this.warningCount - res['dnc_count']} exit requests on behalf of ${orgName}.\n\nRecipients who have chosen not to be contacted or who have received an exit request within the last 7 days have been excluded.`;
      }
      else {
        message = $localize`You are sending ${this.total - this.warningCount - res['dnc_count']} exit request on behalf of ${orgName}.\n\nRecipients who have chosen not to be contacted or who have received an exit request within the last 7 days have been excluded.`;
      }
      let initialState = {
        "title": $localize`Confirm request`,
        "message": message,
        "icon": this.org['logo'] || this.defaultLogo,
        "errorText": errorText,
        "agreeButton": $localize`Send request`,
        "disableAgree": (res['required_profile_credit'] > res['profile_credit']['remaining_profile_credits']) ? true : false
      };
      this.sendExitRequest(initialState);
    });
    }

  sendPulseRequest() {
    if (this.isScheduleDateTimeBeforeCurrentTime()) {
      this.isScheduleDateTimeInPast = true;
      this.disableSend = true;
    }
    else {
      this.isScheduleDateTimeInPast = false;
      this.disableSend = false;
      let orgName = this.setOrgName();
      let initialState = {
        "title": $localize`Confirm request`,
        "message": $localize`You are sending ${this.total} pulse requests on behalf of ${orgName}.`,
        "icon": this.org['logo'] || this.defaultLogo,
        "agreeButton": this.isScheduleDateTimeSet ? $localize`Schedule request` : $localize`Send request`
      };
      this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
        class: 'modal-dialog-centered', initialState
      });
      this.bsModalRef.content.selection.subscribe((res) => {
        if (res == true) {
          localStorage.setItem('requests-page-selected-tab', 'pulse');
          let payload = {
            expiry: {
              expiry_time: moment(this.cutOffExpiry.time, ["h:mm A"]).format("HH:mm:ss"),
              expiry_date: moment(this.cutOffExpiry.date, "DD/MM/YYYY").format('YYYY-MM-DD'),
              expiry_timezone: this.cutOffExpiry.timeZone
            },
            isCutOffCustomized: this.isCutoffCustomised,
            editPulseCustomised: this.editPulseCustomised,
            schedule: {
              scheduled_time: this.scheduleExpiry.time ? moment(this.scheduleExpiry.time, ["h:mm A"]).format("HH:mm:ss") : '',
              scheduled_date: this.scheduleExpiry.date ? moment(this.scheduleExpiry.date, "DD/MM/YYYY").format('YYYY-MM-DD') : '',
              scheduled_timezone: this.scheduleExpiry.timeZone
            },
          }
          payload["timezone"] = this.cutOffExpiry.timeZone ? this.cutOffExpiry.timeZone : this.scheduleExpiry.timeZone;


          this.requestService.sendPulse(localStorage.getItem('draft_pulse_uid'), this.questionnaireIdSelected, 'pulse_request', this.updatedTemplates, payload).subscribe((data: any) => {
            localStorage.removeItem('draft_pulse_uid');
            this.total = 0;
            this.updateSendButton();
            this.messages = [];
            this.router.navigate(
              ['requests'],
              { state: { originPage: 'success' } });
          },
            (error: any) => {
              for (const [key, value] of Object.entries(error.error['data']['errors'])) {
                let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
                let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
                this.messages = this.messages.concat([{
                  'key': key,
                  'type': message['type'],
                  'message': message['message']
                }]);
              }
              this.updateSendButton();
            })
        }
      })
    }
  }

  sendBackgroundCheck(use_ref=false) {
    let orgName = this.setOrgName();
    const errorText = $localize`Once a background check has been sent, it cannot be stopped or deleted.`;
    let message = '';
    const noOfChecks:number = this.total * (this.selectedBackgroundChecks && this.selectedBackgroundChecks.length > 0 ? this.selectedBackgroundChecks.length: 1)
    if (noOfChecks > 1) {
      message = $localize`You are sending ${noOfChecks} background checks on behalf of ${orgName}.`;
    } else {
      message = $localize`You are sending ${noOfChecks} background check on behalf of ${orgName}.`;
    }

    let initialState = {
      "title": $localize`Confirm request`,
      "icon": this.org['logo'] || this.defaultLogo,
      "message": message,
      "errorText": errorText,
      "agreeButton": $localize`Send request`,
      'typeModal': 'background-check'
    };

    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        localStorage.setItem('requests-page-selected-tab', 'backGroundCheck');
        let draft_uid;
        if(use_ref){
            draft_uid = localStorage.getItem('draft_reference_uid')
        }
        else{
            draft_uid = localStorage.getItem('draft_background_check_uid')
        }
        this.requestService.sendExternalCheck(
          draft_uid,
          undefined, undefined,
          'Background Check', undefined, this.selectedTemplate
        ).subscribe((data: any) => {
          if(use_ref){
              localStorage.removeItem('draft_reference_uid');
          }
          else{
              localStorage.removeItem('draft_background_check_uid');
          }
          this.total = 0;
          this.updateSendButton();
          this.messages = [];
          this.router.navigate(
              ['requests'],
              {state: {originPage: 'success'}});
        },
        (error: any) => {
          console.log(error);
          for (const [key, value] of Object.entries(error.error['data']['errors'])) {
            let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
            let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
            this.messages = this.messages.concat([{
              'key': key,
              'type': message['type'],
              'message': message['message']
            }]);
          }
            this.updateSendButton();
          })
      }
    })
  }

  isScheduleDateTimeBeforeCurrentTime() {
    const selectedDateTime = moment(`${this.scheduleExpiry.date} ${this.scheduleExpiry.time}`, "DD-MM-YYYY HH:mm a");
    let now = moment()
    now = moment.tz(now, this.scheduleExpiry.timeZone)
    now = this.addMinutesToDate(now, 30)
    let nowFormatted = now.format("DD-MM-YYYY HH:mm a")
    let selectedDateTimeFormatted = selectedDateTime.format("DD-MM-YYYY HH:mm a")
    return (moment(nowFormatted, 'DD-MM-YYYY HH:mm a').isAfter(moment(selectedDateTimeFormatted, 'DD-MM-YYYY HH:mm a')))
  }

  addMinutesToDate(date, interval){
    const minutesObj = date.minutes();
    const remainder = minutesObj % interval
    if(remainder !==0){
      const diffObj = interval - remainder
      date.add(diffObj, "m");
    }
    return date
  }

  sendExitRequest(initialState) {
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        localStorage.setItem('requests-page-selected-tab', 'exit');
        this.requestService.sendRequest(localStorage.getItem('draft_uid'), this.questionnaireIdSelected, 'exit_request' , this.updatedTemplates).subscribe((data: any) => {
          localStorage.removeItem('draft_uid');
          this.total = 0;
          this.updateSendButton();
          this.messages = [];
          this.router.navigate(
            ['requests'],
            {state: {originPage: 'success'}});
        },
          (error: any) => {
            console.log(error);
            for (const [key, value] of Object.entries(error.error['data']['errors'])) {
              let key_map = this.errorMap.has(key) ? this.errorMap.get(key) : new Map();
              let message: string = key_map?.has(value) ? key_map?.get(value) : $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`
              this.messages = this.messages.concat([{
                'key': key,
                'type': message['type'],
                'message': message['message']
              }]);
            }
            this.updateSendButton();
          })
      }
    })
  }

  isDirty(): boolean {
    if (this.checkType === ConstantsService.EXIT_CHECK) return localStorage.getItem('draft_uid') !== null;
    else {
      if (this.checkType === ConstantsService.BACKGROUND_CHECK) return localStorage.getItem('draft_background_check_uid') !== null;
      if (this.checkType === ConstantsService.REFERENCE_CHECK) return localStorage.getItem('draft_reference_uid') !== null;
      return localStorage.getItem('draft_pulse_uid') !== null;
    }
  }

  resetToDefault(){
    this.defaultTimeZone = this.org['timezone']
    this.cutOffExpiry.time = moment(new Date()).tz(this.defaultTimeZone).format("h:mm A");
    this.cutOffExpiry.date=moment(new Date()).tz(this.defaultTimeZone).add(3, 'w').format('DD/MM/YYYY');
    this.cutOffExpiry.timeZone=this.defaultTimeZone
    this.scheduleExpiry.timeZone=this.defaultTimeZone
    this.isCutoffCustomised=false
  }

  emptyScheduledCheck(){
    return this.scheduleExpiry.date === "" && this.scheduleExpiry.time === "";
  }

  cutOffScheduleDatePickerModal(checkType) {
    if(checkType===ConstantsService.SCHEDULE && this.emptyScheduledCheck()){
      this.isScheduleDateTimeSet= !this.isFirstOpen
    }

    let initialState = {
      "checkType": checkType,
      "selectedCutOffExpiry":this.cutOffExpiry,
      "selectedScheduleExpiry":this.scheduleExpiry,
    };
    this.bsModalRef = this.modalService.show(XrefCutOffScheduleDatePickerModalComponent, {
      class: 'modal-dialog-centered max-width-552 m-popup', initialState,ignoreBackdropClick: true
    });
    this.bsModalRef.content.saveClick.subscribe(modalRes=>{
      this.scheduleExpiry.timeZone = modalRes.data.timeZone ? modalRes.data.timeZone : this.org['timezone']
      this.cutOffExpiry.timeZone = modalRes.data.timeZone ? modalRes.data.timeZone : this.org['timezone']
      if (modalRes.data.checkType === ConstantsService.CUT_OFF) {
        this.cutOffExpiry.date = modalRes.data.date ? modalRes.data.date : this.cutOffExpiry.date;
        this.cutOffExpiry.time = modalRes.data.time ? modalRes.data.time : this.cutOffExpiry.time;
        this.isCutoffCustomised=true
        if(this.scheduleExpiry.time && this.scheduleExpiry.date){
          this.updateSendButton()
        }
      }
      else if (modalRes.data.checkType === ConstantsService.SCHEDULE) {
        this.scheduleExpiry.date = modalRes.data.date ? modalRes.data.date : ''
        this.scheduleExpiry.time = modalRes.data.time ? modalRes.data.time : moment(new Date()).format("hh:mm A");
        this.isFirstOpen=true
        this.isScheduleDateTimeSet=true
        this.updateSendButton()
      }
    })
    this.bsModalRef.content.cancelClick.subscribe((cancelClick) => {
      if(cancelClick?.checkType === ConstantsService.SCHEDULE && this.emptyScheduledCheck()){
        this.isScheduleDateTimeSet=false
        this.updateSendButton()
      }
    })
  }

  toggleAccordion(event){
    this.isFirstOpen = event
  }

  navigateToAccount(){
    this.router.navigate(['account']);
  }

  resetToDefaultScheduleDateTime(){
    this.isFirstOpen = !this.isFirstOpen,
      this.scheduleExpiry.date = '';
    this.scheduleExpiry.time = '';
    this.isScheduleDateTimeSet = false;
    this.updateSendButton()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    setPageDirtyFlag(false);
    if (this.checkType === ConstantsService.EXIT_CHECK) {
      if (localStorage.getItem('draft_uid') !== null) {
        this.clearDraftUid();
      }
    } else if (this.checkType === ConstantsService.REFERENCE_CHECK) {
      if (localStorage.getItem('draft_reference_uid') !== null) {
        this.clearReferenceDraftUid();
      }
    } else if (this.checkType === ConstantsService.BACKGROUND_CHECK) {
      if (localStorage.getItem(' draft_background_check_uid') !== null) {
        this.clearBackgroundCheckDraftUid();
      }
    }
    this.clearDraftServiceSubscription.unsubscribe();
  }

  goBack() {
    this.clearDraft();
    this.router.navigateByUrl('requests')
    this.permissions.setNavCheck(true);
  }
  onReplaceTemplate(){
    this.bsModalRef = this.modalService.show(SelectTemplateModalComponent, {
      class: 'modal-dialog modal-dialog-centered xl-popup padding-0',
      initialState: {}
    });
    this.bsModalRef.content.templateSelect.pipe(take(1)).subscribe((res: any) => {
      if (res?.template) {
          this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
              class: 'modal-dialog-centered',
              initialState: {
                "title": $localize`Replace the selected package?`,
                "message": $localize`Replacing the package will update the request settings and remove any added recipients.\n\nAre you sure you want to continue?`
              }
          });
          this.bsModalRef.content.selection.pipe(take(1)).subscribe(response => {
              if (response === true) {
                // Process the selected template similar to how selectedTemplate is processed
                this.selectedTemplate = this.processSingleTemplate(res.template);
                this.selectedBackgroundChecks = [];
                this.flowsSelected = [];
                this.selectedBackgroundChecksIds = [];
                this.bgCheckShortNames = [];
                this.disableRecipientListButtons = false;
                this.recipients = {};
                // Clear stale package API settings; loadTemplateBGC repopulates
                // (behind the flag) only when the new template has a background config.
                this.packageApiSettings = {};
                localStorage.removeItem('draft_reference_uid');
                this.checkType = ConstantsService.REFERENCE_CHECK;
                this.resetVariables();
                const background_config = this.selectedTemplate?.config?.find((c: any) => c.type === 'background');
                if(background_config?.partner_checks){
                    this.loadTemplateBGC(background_config);
                }
                this.loadTemplateData();
              }
          });

      }
    });

  }

  checkOverflow(element: any): boolean {
    if (!element) {
      return false;
    }
    const el = element.nativeElement || element;
    if (!el || typeof el.offsetWidth === 'undefined' || typeof el.scrollWidth === 'undefined') {
      return false;
    }
    return el.offsetWidth < el.scrollWidth;
  }

  getTimesUsedText(timesUsed: number): string {
    if (timesUsed === 0 || timesUsed === null || timesUsed === undefined) {
      return '0';
    }
    return timesUsed.toString();
  }

  get showXmeSearch(): boolean {
    return this.checkType === ConstantsService.REFERENCE_CHECK && this.ent_11525_unlock_xref_me;
  }

  get xmeInteractionLocked(): boolean {
    return this.ent_11525_unlock_xref_me && this.xmeRequesting;
  }

  get xmeMatchCase(): XmeMatchCase | null {
    return this.xmeResult?.case || null;
  }

  /** Unlocked is already unlocked, so a withheld request there is not a credit problem. */
  get xmeInsufficientCredit(): boolean {
    return this.xmeState === 'matched'
      && this.xmeMatchCase !== 'unlocked'
      && this.xmeResult?.credits_available === 0;
  }

  onXmeSearch(query: string): void {
    const generation = ++this.xmeSearchGeneration;
    this.xmeQuery = query;
    this.xmeState = 'searching';
    this.xmeResult = null;
    this.xmeTeaser = null;

    this.xmeService.search(query)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: result => {
          if (generation !== this.xmeSearchGeneration) {
            return;
          }
          this.applyXmeSearchResult(result);
        },
        error: () => {
          if (generation !== this.xmeSearchGeneration) {
            return;
          }
          this.xmeState = 'idle';
          this.alertList.append([{
            type: AlertType.DANGER,
            message: this.xmePlatformErrorMessage,
            keepOnRouteChange: true
          }]);
        }
      });
  }

  applyXmeSearchResult(result: XmeSearchResponse): void {
    this.xmeResult = result;

    if (!result?.match || !result.teaser) {
      this.xmeState = 'no-match';
      this.xmeTeaser = null;
      this.xmeNoMatchMessage = $localize`An Xref.me profile is currently not published for ${this.xmeQuery}. Continue with sending a reference request below.`;
      return;
    }

    this.xmeTeaser = toSearchResultTeaser(result.teaser);

    // Requested unlock still shows the match card (locked/new/unlocked). The
    // requested success strip is only after a successful request-verifications.
    this.xmeState = 'matched';
    this.xmeCreditFooter = this.buildXmeCreditFooter(result);
  }

  /**
   * Plain footer copy; optional `{highlight}` is emphasised via creditHighlight (no HTML).
   * Append `{highlight}` outside `$localize` — curly braces are ICU syntax inside tagged templates.
   */
  buildXmeCreditFooter(result: XmeSearchResponse): string {
    const firstName = (result.teaser?.name || '').split(' ')[0];
    this.xmeCreditHighlight = null;
    if (result.case === 'unlocked') {
      return $localize`You already have full profile access.`;
    }
    if (result.case === 'locked') {
      return $localize`Once ${firstName} approves, you’ll get full profile access and downloadable reports for 30 days.`;
    }
    this.xmeCreditHighlight = '1';
    return $localize`Once ${firstName} approves, you’ll get full profile access and downloadable reports for 30 days, increasing your turnover cap usage by `
      + '{highlight}.';
  }

  onXmeRequestVerifications(): void {
    if (
      !this.ent_11525_unlock_xref_me
      || this.xmeRequesting
      || !this.xmeResult?.can_request
    ) {
      return;
    }
    this.xmeRequesting = true;

    this.xmeService.requestVerifications(this.xmeQuery, this.xmeResult?.xme_user_id)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.xmeRequesting = false),
      )
      .subscribe({
        next: result => {
          this.xmeState = 'requested';
          const firstName = (this.xmeResult?.teaser?.name || '').split(' ')[0];
          this.xmeRequestedMessage = result.person_created
            ? $localize`Success! ${firstName}’s profile is being created, and your request to access their verifications has been sent.`
            : $localize`Success! ${firstName}’s profile has been linked, and your request to access their verifications has been sent.`;
        },
        error: () => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: this.xmePlatformErrorMessage,
            keepOnRouteChange: true
          }]);
        }
      });
  }

  onXmeViewProfile(): void {
    if (this.xmeViewing) {
      return;
    }
    this.xmeViewing = true;

    if (this.xmeMatchCase === 'unlocked' && this.xmeResult?.can_view) {
      const ids = this.xmeResult.person_uid
        ? { person_uid: this.xmeResult.person_uid }
        : null;
      if (!ids) {
        this.openXmePublicProfileFresh();
        return;
      }
      this.xmeService.viewerSession(ids).pipe(
        take(1),
        finalize(() => this.xmeViewing = false),
      ).subscribe({
        next: (session: any) => {
          if (session?.viewer_url) {
            this.openXmeUrl(session.viewer_url);
            return;
          }
          this.showXmePlatformError();
        },
        error: () => this.showXmePlatformError(),
      });
      return;
    }
    if (this.isXmeRequestedView()) {
      this.openXmePublicProfileCached('requested');
      this.xmeViewing = false;
      return;
    }
    this.openXmePublicProfileFresh();
  }

  private isXmeRequestedView(): boolean {
    return this.xmeState === 'requested'
      || isXmeRequestedUnlockStatus(this.xmeResult?.unlock_status);
  }

  private showXmePlatformError(): void {
    this.alertList.append([{
      type: AlertType.DANGER,
      message: this.xmePlatformErrorMessage,
      keepOnRouteChange: true
    }]);
  }

  private openXmePublicProfileCached(state?: XmeOriginState): void {
    const url = this.xmeResult?.teaser?.profile_url;
    if (!url) {
      this.showXmePlatformError();
      return;
    }
    this.openXmeUrl(url, state);
  }

  private openXmePublicProfileFresh(): void {
    const query = (
      this.xmeResult?.teaser?.matched_email
      || this.xmeQuery
      || ''
    ).trim();
    if (!query) {
      this.showXmePlatformError();
      this.xmeViewing = false;
      return;
    }
    this.xmeService.search(query).pipe(
      take(1),
      finalize(() => this.xmeViewing = false),
    ).subscribe({
      next: (result) => {
        const url = result?.teaser?.profile_url;
        if (!url) {
          this.showXmePlatformError();
          return;
        }
        const state: XmeOriginState | undefined = isXmeRequestedUnlockStatus(result.unlock_status)
          ? 'requested'
          : undefined;
        this.openXmeUrl(url, state);
      },
      error: () => this.showXmePlatformError(),
    });
  }

  openXmeUrl(url?: string | null, state?: XmeOriginState): void {
    if (!url) {
      return;
    }
    try {
      const parsed = new URL(url);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        this.showXmePlatformError();
        return;
      }
    } catch {
      this.showXmePlatformError();
      return;
    }
    window.open(
      appendXmeOrigin(url, state),
      '_blank',
      'noopener',
    );
  }

  resetXmeSearch(): void {
    if (this.xmeInteractionLocked) {
      return;
    }
    this.xmeSearchGeneration++;
    this.xmeState = 'idle';
    this.xmeQuery = '';
    this.xmeResult = null;
    this.xmeTeaser = null;
    this.xmeRequesting = false;
    this.xmeViewing = false;
  }

    protected readonly ConstantsService = ConstantsService;
}
